import cn from "classnames";
import { Title3 } from "@components/new/Typo";
import { TableColumnSkeleton } from "./TableTypes";
import Checkbox from "@components/new/Checkbox";
import { FilterModel } from '@hooks/useFiltersSearchParams';
import SortUpIcon from "@assets/icons/outline/arrow-up-narrow-wide.svg?react";
import SortDownIcon from "@assets/icons/outline/arrow-down-narrow-wide.svg?react";
import styles from "./Table.module.scss";

export type TableHeadProps = {
  columns: TableColumnSkeleton[];
  onSortingChange?: (column: string, direction: string) => void;
  sorting?: { column: string, direction: string };
  filters?: FilterModel[];
  isSelectable?: boolean;
  selected?: boolean | "partial";
  toggleSelectAll?: () => void;
};

function TableHead(props: TableHeadProps): JSX.Element {
  return (
    <thead>
      <tr className={styles.headRow}>
        {props.isSelectable && (
          <th className={styles.headerCell}>
            <div className={styles.content}>
              <Checkbox
                checked={props.selected ?? false}
                onChange={() => (props.toggleSelectAll && props.toggleSelectAll())}
              />
            </div>
          </th>
        )}
        {props.columns.map((column, index) => {
          const isActiveSort = column.sortable && (props.sorting?.column === column.id);
          const sortingDirection = isActiveSort ? (props.sorting?.direction ?? 'asc') : 'asc';

          return (
            <th
              key={index}
              className={cn(
                styles.headerCell,
                styles[`alignment-${column.alignment ?? 'left'}`],
              )}
              style={{
                [column.fixWidth ? 'width' : 'maxWidth']: column.width
              }}
            >
              <div className={styles.content}>
                <Title3 className={styles.headerTitle}>{column.header}</Title3>
                {column.sortable ? (
                  <button
                    type="button"
                    className={cn(styles.sortingButton, isActiveSort && styles.activeSorting)}
                    onClick={() => {
                      props.onSortingChange && props.onSortingChange(
                        column.id ?? "",
                        isActiveSort ? (sortingDirection === 'asc' ? 'desc' : 'asc') : sortingDirection,
                      );
                    }}
                  >
                    {sortingDirection === 'asc' ? <SortUpIcon /> : <SortDownIcon />}
                  </button>
                ) : null}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

export default TableHead;
